import { render, staticRenderFns } from "./ErrorDisplay.vue?vue&type=template&id=59174daa&scoped=true&lang=pug"
import script from "./ErrorDisplay.vue?vue&type=script&lang=ts"
export * from "./ErrorDisplay.vue?vue&type=script&lang=ts"
import style0 from "./ErrorDisplay.vue?vue&type=style&index=0&id=59174daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59174daa",
  null
  
)

export default component.exports